import sanity from './sanity-base.service';

const fetchTests = () => {
  const query = `*[_type == "tests"]`;
  return sanity.fetch(query);
};

const fetchTest = (id) => {
  const query = `*[_id == "${id}"]{
    ...,
    questions[]->{
      ...,
      "description": description[]{
        ...,
        "imageUrl": asset->url
      },
      "options": options[]{
        ...,
        "imageUrl": image.asset->url
      }
    }
  }`;
  return sanity.fetch(query);
};

const fetchSignsQuestions = () => {
  return import('./../assets/dataset/obazrivko-traffic-signs-questions.json');
}

export {
  fetchTests,
  fetchTest,
  fetchSignsQuestions
};